import { Size } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Changeable, { ChangeEvent, ChangeEventListener } from '@philips-emr/tws-core/lib/component/types/changeable';
import Focusable, { FocusEventListener } from '@philips-emr/tws-core/lib/component/types/focusable';
import Keyboardable, { KeyboardEventListener } from '@philips-emr/tws-core/lib/component/types/keyboardable';
import { isEnumValid } from '@philips-emr/tws-utils';

class TextAreaAPI extends ComponentAPI implements Changeable<string>, Focusable, Keyboardable {
  /** @event */
  @AwesomeEvent
  onChange = new ChangeEventListener<string>();

  /** @event */
  @AwesomeEvent
  onBlur = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onFocus = new FocusEventListener();

  /** @event */
  @AwesomeEvent
  onKeyDown = new KeyboardEventListener();

  /** @event */
  @AwesomeEvent
  onKeyPress = new KeyboardEventListener();

  /** @event */
  @AwesomeEvent
  onKeyUp = new KeyboardEventListener();

  isEnabled(): boolean {
    return this.state.enabled;
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  getLength(): number {
    return this.state.length;
  }

  setLength(length: number): void {
    this.setState({ length });
  }

  getName(): string {
    return this.state.name;
  }

  setName(name: string): void {
    this.setState({ name });
  }

  getPlaceholder(): string {
    return this.state.placeholder;
  }

  setPlaceholder(placeholder: string): void {
    this.setState({ placeholder });
  }

  isReadOnly(): boolean {
    return this.state.readOnly;
  }

  setReadOnly(readOnly: boolean): void {
    this.setState({ readOnly });
  }

  isRequired(): boolean {
    return this.state.required;
  }

  setRequired(required: boolean): void {
    this.setState({ required });
  }

  canResize(): boolean {
    return this.state.resize;
  }

  setResize(resize: boolean): void {
    this.setState({ resize });
  }

  getRows(): number {
    return this.state.rows;
  }

  setRows(rows: number): void {
    this.setState({ rows });
  }

  getSize(): Size {
    return this.state.size;
  }

  setSize(size: Size): void {
    if (isEnumValid(Size, size)) {
      this.setState({ size });
    }
  }

  getValue(): string {
    return this.state.value;
  }

  setValue(value: string): void {
    const { value: oldValue } = this.state;
    this.setState({ value });

    this.onChange.fire(new ChangeEvent({ value, oldValue }));
  }
}

export default TextAreaAPI;
